var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-json-editor',{attrs:{"showBtns":false,"mode":_vm.jMode,"lang":"zh"},on:{"json-change":_vm.onJsonChange,"json-save":_vm.onJsonSave},model:{value:(_vm.resultInfo),callback:function ($$v) {_vm.resultInfo=$$v},expression:"resultInfo"}})}
var staticRenderFns = []

export { render, staticRenderFns }